module.exports = __webpack_public_path__ + "static/book-vocabularyBuilder1-65e6bd90b9a7dbf634df67e9f08067c2.png";